import * as rpc from "@1games-ru/rage-rpc";

// const showErrors = (message) => {
//   toast.error(i18next.t(`errors.${message}`));
// };

export function callClient(name, value = {}, options = {}) {
  return new Promise((resolve, reject) => {
    try {
      rpc
        .callClient(name, value, options)
        .then(resolve)
        .catch((error) => {
          // if (error?.message) {
          //   showErrors(error.message);
          // }
          reject(error);
        });
    } catch (error) {
      // showErrors("other");
      reject(error);
    }
  });
}

export function callServer(name, value = {}) {
  return new Promise((resolve, reject) => {
    try {
      console.log(name, value);
      rpc
        .callServer(name, value)
        .then(resolve)
        .catch((error) => {
          // if (error?.message) {
          //   showErrors(error.message);
          // }
          reject(error);
        });
    } catch (error) {
      // showErrors("other");
      reject(error);
    }
  });
}
